import { handleActions } from "redux-actions";

import {
    BRAND_PROFILE_RESET,
    BRAND_PROFILE_FAILURE,
    BRAND_PROFILE_REQUEST,
    BRAND_PROFILE_SUCCESS,
    BRAND_PROFILE_CHANGE,
    BRAND_PROFILE_CHANGE_SUCCESS,
    BRAND_PROFILE_PICTURES_CHANGE,
    BRAND_PROFILE_PICTURES_FAILURE,
    BRAND_PROFILE_PICTURE_CHANGE,
    BRAND_PROFILE_PICTURE_CHANGE_COMPLETE,
    BRAND_PROFILE_EVENTS_SUCCESS,
    BRAND_PROFILE_EVENTS_DELETE_SUCCESS,
    INSTAGRAM_FEED_SUCCESS,
    INSTAGRAM_LINK_SUCCESS,
    INSTAGRAM_LINK_FAILURE,
    INSTAGRAM_UNLINK_FAILURE,
    INSTAGRAM_UNLINK_SUCCESS,
    BRAND_PREFERENCES_UPDATE,
    BRAND_SETTINGS_UPDATE,
    BRAND_PREFERENCES_UPDATE_COMPLETE,
    BRAND_SETTINGS_UPDATE_COMPLETE,
} from "constants/action-types";

interface IState {
    initialized: boolean;
    result: any[];
    isFetching: boolean;
    error?: any;
    updatingPictures: boolean;
    updatingPicture: boolean;
    updatingAttachments: boolean;
    events: any[];
    posts: any[];
    isInstagramLinked: boolean;
}

const initialState = {
    initialized: false,
    result: [],
    isFetching: false,
    error: undefined,
    updatingPictures: false,
    updatingPicture: false,
    updatingAttachments: false,
    events: [],
    posts: [],
    isInstagramLinked: false,
};

const brandProfileReducer = handleActions<IState, any>(
    {
        [BRAND_PROFILE_RESET]: (): IState => {
            return initialState;
        },
        [BRAND_PROFILE_REQUEST]: (state: IState): IState => {
            return Object.assign({}, state, {
                isFetching: true,
                error: undefined,
                initialized: true,
            });
        },
        [BRAND_PROFILE_SUCCESS]: (state: IState, { payload }): IState => {
            return Object.assign({}, state, {
                isFetching: false,
                initialized: true,
                result: payload,
            });
        },
        [BRAND_PROFILE_FAILURE]: (state: IState, error): IState => {
            return Object.assign({}, state, {
                isFetching: false,
                error: error,
                result: initialState.result,
            });
        },
        [BRAND_PROFILE_CHANGE]: (state: IState, { payload }): IState => {
            return Object.assign({}, state, {
                result: payload,
                updatingPictures: false,
            });
        },
        [BRAND_PROFILE_PICTURES_CHANGE]: (state: IState): IState => {
            return Object.assign({}, state, { updatingPictures: true });
        },
        [BRAND_PROFILE_PICTURES_FAILURE]: (state: IState): IState => {
            return Object.assign({}, state, { updatingPictures: false });
        },
        [BRAND_PROFILE_CHANGE_SUCCESS]: (state: IState): IState => {
            return Object.assign({}, state);
        },
        [BRAND_PROFILE_PICTURE_CHANGE]: (state: IState): IState => {
            return Object.assign({}, state, { updatingPicture: true });
        },
        [BRAND_PROFILE_PICTURE_CHANGE_COMPLETE]: (state: IState): IState => {
            return Object.assign({}, state, { updatingPicture: false });
        },
        [BRAND_PROFILE_EVENTS_DELETE_SUCCESS]: (state: IState, { payload }): IState => {
            const events = state.events.filter((event) => {
                return event.id !== payload;
            });
            return Object.assign({}, state, { events });
        },
        [BRAND_PROFILE_EVENTS_SUCCESS]: (state: IState, { payload }): IState => {
            const eventData = payload.body ? payload.body.data : [];
            const events = state.events.concat(eventData);
            return Object.assign({}, state, { events });
        },
        [INSTAGRAM_FEED_SUCCESS]: (state: IState, { payload }): IState => {
            return Object.assign({}, state, {
                posts: payload,
                isFetching: false,
            });
        },
        [INSTAGRAM_LINK_SUCCESS]: (state: IState): IState => {
            return Object.assign({}, state);
        },
        [INSTAGRAM_LINK_FAILURE]: (state: IState): IState => {
            return Object.assign({}, state);
        },
        [INSTAGRAM_UNLINK_SUCCESS]: (state: IState): IState => {
            return Object.assign({}, state);
        },
        [INSTAGRAM_UNLINK_FAILURE]: (state: IState): IState => {
            return Object.assign({}, state);
        },
        [BRAND_PREFERENCES_UPDATE]: (state: IState): IState => {
            return Object.assign({}, state, { isFetching: true });
        },
        [BRAND_SETTINGS_UPDATE]: (state: IState): IState => {
            return Object.assign({}, state, { isFetching: true });
        },
        [BRAND_PREFERENCES_UPDATE_COMPLETE]: (state: IState): IState => {
            return Object.assign({}, state, { isFetching: false });
        },
        [BRAND_SETTINGS_UPDATE_COMPLETE]: (state: IState): IState => {
            return Object.assign({}, state, { isFetching: false });
        },
    },
    initialState,
);

export default brandProfileReducer;
